module.exports = __webpack_public_path__ + "images/1e2069a7e4688214be8e5fb0b9f2fc95-IMG_8755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_8755.jpg
// module id = ./src/assets/images/slides/living2/IMG_8755.jpg
// module chunks = 0